<template>
  <div class="form-group">
    <label for="name_on_card">{{ $t("address.businessname") }}</label>
    <input
      v-model="business_name"
      class="form-control"
      :placeholder="$t('address.businessname')"
      type="text"
      name="name"
    />

    <ValidationProvider
      rules="required"
      v-slot="{ errors, valid, validated, required }"
      :name="$t('address.country')"
      slim
    >
      <b-form-group
        :invalid-feedback="errors[0]"
        :state="required && validated ? valid : undefined"
        :label="$t('address.country')"
        label-class="label-required"
        label-for="country"
      >
        <b-form-select
          v-model.lazy="country_code"
          :options="shipping.countries"
          :state="required && validated ? valid : undefined"
          option-value="value"
          option-text="value"
          id="country"
        />
      </b-form-group>
    </ValidationProvider>

    <ValidationProvider
      rules="required"
      v-slot="{ errors, valid, validated, required }"
      :name="$t('address.street1')"
      slim
    >
      <b-form-group
        :invalid-feedback="errors[0]"
        :state="required && validated ? valid : undefined"
        :label="$t('address.street1')"
        label-class="label-required"
        label-for="address1"
      >
        <b-form-input
          id="address1"
          v-model="address1"
          :state="required && validated ? valid : undefined"
          name="address1"
          type="text"
          :placeholder="$t('address.street1')"
        />
      </b-form-group>
    </ValidationProvider>

    <label for="name_on_card">{{ $t("address.street2") }}</label>
    <input
      v-model="address2"
      class="form-control"
      :placeholder="$t('address.street2')"
      type="text"
      name="name"
    />

    <ValidationProvider
      rules="required"
      v-slot="{ errors, valid, validated, required }"
      :name="$t('address.city')"
      slim
    >
      <b-form-group
        :invalid-feedback="errors[0]"
        :state="required && validated ? valid : undefined"
        :label="$t('address.city')"
        label-class="label-required"
        label-for="city"
      >
        <b-form-input
          id="city"
          v-model.lazy="city"
          :state="required && validated ? valid : undefined"
          name="city"
          type="text"
          :placeholder="$t('address.city')"
        />
      </b-form-group>
    </ValidationProvider>

    <div class="row">
      <div class="col-md-8">
        <ValidationProvider
          rules="required"
          v-slot="{ errors, valid, validated, required }"
          :name="$t('address.state')"
          slim
        >
          <b-form-group
            :invalid-feedback="errors[0]"
            :state="required && validated ? valid : undefined"
            :label="$t('address.state')"
            label-class="label-required"
            label-for="state"
          >
            <b-form-input
              id="province"
              v-model.lazy="province"
              :state="required && validated ? valid : undefined"
              name="province"
              type="text"
              :placeholder="$t('address.state')"
            />
          </b-form-group>
        </ValidationProvider>
      </div>

      <div class="col-md-4">
        <ValidationProvider
          rules="required"
          v-slot="{ errors, valid, validated, required }"
          :name="$t('address.zip')"
          slim
        >
          <b-form-group
            :invalid-feedback="errors[0]"
            :state="required && validated ? valid : undefined"
            :label="$t('address.zip')"
            label-class="label-required"
            label-for="postal_code"
          >
            <b-form-input
              id="postal_code"
              v-model.lazy="postal_code"
              :state="required && validated ? valid : undefined"
              name="postal_code"
              type="text"
              :placeholder="$t('address.zip')"
            />
          </b-form-group>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";

export default {
  computed: {
    ...mapState({
      billing: (state) => state.cart.billing,
      shipping: (state) => state.shipping,
    }),
    business_name: sync("billing@location.business_name"),
    country_code: sync("billing@location.country_code"),
    address1: sync("billing@location.address1"),
    address2: sync("billing@location.address2"),
    city: sync("billing@location.city"),
    province: sync("billing@location.province"),
    postal_code: sync("billing@location.postal_code"),
  },
};
</script>
